import loadGA from '../loaders/loadGoogleAnalytics';

export function isLoaded() {
  return Boolean(window.ga);
}

export function load() {
  const gaTrackingID = process.env.REACT_APP_GA_TRACKING_ID;

  if (!isLoaded()) {
    loadGA();
  }

  if (gaTrackingID) {
    window.ga('create', gaTrackingID, 'auto');
  }

  if (process.env.REACT_APP_ENV !== 'production') {
    window.ga('set', 'sendHitTask', null);
  }
}

export function trackDialog(name, path) {
  this.trackScreen(name, `/modal/${path}`);
}

export function trackEvent(data) {
  if (isLoaded()) {
    window.ga('send', {
      hitType: 'event',
      eventAction: data.action,
      eventCategory: data.category,
      eventLabel: data.label
    });
  }
}

export function trackOutboundLink(target) {
  if (isLoaded()) {
    window.ga('send', {
      hitType: 'event',
      eventAction: 'click',
      eventCategory: 'Outbound Link',
      eventLabel: target,
      transport: 'beacon'
    });
  }
}

export function trackScreen(name, page = window.location.pathname) {
  if (isLoaded()) {
    window.ga('send', {
      hitType: 'pageview',
      title: name,
      page
    });
  }
}
